<script setup lang="ts">
import type Schema from "~/types/Schema";
import type SchemaParent from "~/types/SchemaParent";
import { computed } from "vue";
import useLowerCamelCase from "../../utils/useLowerCamelCase";

const props = defineProps({
  schema: {
    type: Object as PropType<Schema>,
    required: true,
  },
  parents: {
    type: Array as PropType<SchemaParent[]>,
    default: () => [],
  },
});

const search = ref("");
// Filter out children based on the search term.
const filteredParents = computed(() =>
  props.parents.filter(
    (parent) =>
      parent.recordId.toLowerCase().includes(search.value.toLowerCase()) ||
      parent.parentName.toLowerCase().includes(search.value.toLowerCase()) ||
      parent.parentDescription.toLowerCase().includes(search.value.toLowerCase()),
  ),
);
</script>

<template>
  <div class="p-4">
    <div class="mb-4 text-right">
      <SearchBox v-model="search" class="lg:inline-block lg:w-1/3" />
    </div>

    <!-- List items -->
    <ListItems :items="filteredParents">
      <template #header>
        <div class="mr-2 flex-none lg:w-1/4 xl:w-72">Name</div>

        <div class="flex-1">Description</div>
      </template>

      <template #row="{ item, useXL }">
        <div
          class="mr-2 flex-none overflow-hidden font-bold"
          :class="useXL ? 'xl:w-72 xl:font-normal' : 'lg:w-1/4 lg:font-normal'"
        >
          {{ useLowerCamelCase(item) ? item.parentLowerCamelName : item.parentCamelCaseName }}
        </div>

        <div class="mt-2 flex-1 lg:mt-0">{{ item.parentDescription }}</div>
      </template>
    </ListItems>
  </div>
</template>

<style scoped></style>
